module.exports = __webpack_public_path__ + "static/img/Joox.e53137fa.png";